/* eslint-disable */
import axios from 'axios'

function requestNextTick(cb: any) {
	if (window.requestIdleCallback) {
		window.requestIdleCallback(cb)
	} else {
		setTimeout(cb, 0)
	}
}

class User {
	addressCount: number | null
	emailVerified: 'yes' | 'no' | null
	onboarded: 'yes' | 'no' | null
	orderCount: number | null
	referralCompletedCount: number | null
	referralInvited_count: number | null
	shipmentCount: number | null
	usableCredits: number | null
	summaryProgress: number | null
	getUserSummaryIdleResolver: any

	constructor() {
		this.addressCount = null
		this.emailVerified = null
		this.onboarded = null
		this.orderCount = null
		this.referralCompletedCount = null
		this.referralInvited_count = null
		this.shipmentCount = null
		this.usableCredits = null
		this.summaryProgress = null
		this.getUserSummaryIdleResolver = new Promise(requestNextTick).then(
			this.fetchUserSummary.bind(this),
		)
	}

	async fetchUserSummary() {
		if (!window.BsHeaderVm.isLoginGlobal)
			return Promise.resolve({ msg: 'not login' })
		return axios
			.get(`${window.BUYANDSHIP.settings.api_url}users/me/summary`)
			.then(({ data: { data } }) => {
				if (!data) return
				this.addressCount = data.address_count
				this.emailVerified = data.email_verified
				this.onboarded = data.onboarded
				this.orderCount = data.order_count
				this.referralCompletedCount = data.referral_completed_count
				this.referralInvited_count = data.referral_invited_count
				this.shipmentCount = data.shipment_count
				this.usableCredits = data.usable_credits
				this.summaryProgress = (() => {
					if (this.orderCount !== 0) return 5
					if (this.shipmentCount !== 0) return 4
					if (this.addressCount) return 3
					if (this.onboarded) return 2
					if (this.emailVerified) return 1
					return 0
				})()

				return this.summaryProgress
			})
			.catch(err => console.log(err))
	}

	getUserSummary() {
		return this.fetchUserSummary
	}

	getUserSummaryIdle() {
		if (this.summaryProgress) return Promise.resolve(this.summaryProgress)
		return this.getUserSummaryIdleResolver
	}
}

export default User
